(() => {
  if (!document.body.classList.contains('preview-theme-expanded')) {
    return;
  }

  const isProductTemplate = document.body.classList.contains('template-product');
  const isCollectionTemplate = document.body.classList.contains('template-collection');
  const isIndexTemplate = document.body.classList.contains('template-index');
  const productSelector = '.template-product .product.product--with-app-rail';
  const reviewWrapperSelector = '.product__reviews-wrapper';
  const reviewWidgetSelector = '.reputon-etsy-reviews-widget';
  const reviewSummarySelector = '[data-review-summary]';
  const staleDescriptionCopyFixes = {
    'cherry-blossom-spring-dragon-3d-print': [
      {
        find:
          'The dragon can be ordered in a single color or gradient, where the entire dragon and blossoms are the same color option; or can be ordered in dual color where the primary color is selected during checkout while the cherry blossom colors are selected and added to the personalization box.',
        replace:
          'The dragon can be ordered in a single color or gradient, where the entire dragon and blossoms are the same color option; or can be ordered in dual color where the primary color is selected during checkout and the cherry blossom color is chosen from the Secondary Color dropdown.',
      },
    ],
  };
  const collectionCardSelector =
    '.template-collection .product-card-wrapper[data-product-handle], .template-index .product-card-wrapper[data-product-handle]';
  const reviewMap = window.previewThemeReputonReviewMap || {};
  const expectedListingMap = window.previewThemeReputonExpectedListingMap || {};

  function ensureFaqHeaderLink() {
    const faqHref = '/pages/faq';

    document.querySelectorAll('.header__inline-menu .list-menu--inline').forEach((menu) => {
      if (!(menu instanceof HTMLElement)) {
        return;
      }

      const hasFaq = [...menu.querySelectorAll('a')].some((link) => {
        return (link.getAttribute('href') || '').includes(faqHref);
      });

      if (hasFaq) {
        return;
      }

      const item = document.createElement('li');
      item.innerHTML = `
        <a id="HeaderMenu-faq-fallback" href="${faqHref}" class="header__menu-item list-menu__item link link--text focus-inset">
          <span>FAQ</span>
        </a>
      `;
      menu.appendChild(item);
    });

    document.querySelectorAll('.menu-drawer__menu').forEach((menu) => {
      if (!(menu instanceof HTMLElement)) {
        return;
      }

      const hasFaq = [...menu.querySelectorAll('a')].some((link) => {
        return (link.getAttribute('href') || '').includes(faqHref);
      });

      if (hasFaq) {
        return;
      }

      const item = document.createElement('li');
      item.innerHTML = `
        <a id="HeaderDrawer-faq-fallback" href="${faqHref}" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">
          FAQ
        </a>
      `;
      menu.appendChild(item);
    });
  }

  function removeHomepageFaqCta() {
    if (!isIndexTemplate) {
      return;
    }

    document.querySelectorAll('a.button, button.button').forEach((button) => {
      const label = (button.textContent || '').trim();
      if (/^read the faq$/i.test(label)) {
        const buttonParent = button.closest('.rich-text__buttons');
        if (buttonParent instanceof HTMLElement) {
          buttonParent.remove();
        } else {
          button.remove();
        }
      }
    });
  }

  function parseReviewCount(value) {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value;
    }

    if (typeof value === 'string') {
      const normalized = value.replace(/[^\d.]/g, '');
      const parsed = Number.parseFloat(normalized);
      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }

    return 0;
  }

  function extractReputonReviewData(wrapper) {
    if (!(wrapper instanceof HTMLElement)) {
      return null;
    }

    const sourceText = wrapper.textContent || '';
    const match = sourceText.match(/window\.reputonEtsyProductReviewsData\s*=\s*(\{[\s\S]*?\});/);

    if (!match) {
      return null;
    }

    try {
      return JSON.parse(match[1]);
    } catch (error) {
      return null;
    }
  }

  function wrapperHasRenderedReviews(wrapper) {
    if (!(wrapper instanceof HTMLElement)) {
      return false;
    }

    if (wrapper.querySelector("iframe[src*='reputon']")) {
      return true;
    }

    const widget = wrapper.querySelector(reviewWidgetSelector);
    if (!(widget instanceof HTMLElement)) {
      return false;
    }

    const text = widget.textContent ? widget.textContent.replace(/\s+/g, '').trim() : '';
    return widget.children.length > 0 && text.length > 0;
  }

  function blockHasRenderedReviews(block) {
    if (!(block instanceof HTMLElement)) {
      return false;
    }

    if (block.querySelector("iframe[src*='reputon']")) {
      return true;
    }

    if (
      block.querySelector(
        '.reputon-reviews-holder, .reputon-carousel-container, .reputon-card, .reputon-single-review'
      )
    ) {
      return true;
    }

    const widget = block.matches(reviewWidgetSelector) ? block : block.querySelector(reviewWidgetSelector);
    if (!(widget instanceof HTMLElement)) {
      return false;
    }

    const text = widget.textContent ? widget.textContent.replace(/\s+/g, '').trim() : '';
    return widget.children.length > 0 && text.length > 0;
  }

  function blockLooksEmpty(block) {
    if (!(block instanceof HTMLElement)) {
      return false;
    }

    const widget = block.matches(reviewWidgetSelector) ? block : block.querySelector(reviewWidgetSelector);
    if (!(widget instanceof HTMLElement)) {
      return false;
    }

    if (blockHasRenderedReviews(block)) {
      return false;
    }

    const text = widget.textContent ? widget.textContent.replace(/\s+/g, ' ').trim() : '';
    return text.length === 0;
  }

  function getCurrentProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function reviewPayloadMatchesExpectedListing(wrapper) {
    const handle = getCurrentProductHandle();
    const expectedListingId = expectedListingMap[handle];
    const data = extractReputonReviewData(wrapper);
    const actualListingId = data?.placeId ? String(data.placeId) : '';

    if (!handle || !expectedListingId || !actualListingId) {
      return true;
    }

    return String(expectedListingId) === actualListingId;
  }

  function syncReviewSummary(product, wrapper, hasContent) {
    const summary = product.querySelector(reviewSummarySelector);
    if (!(summary instanceof HTMLElement)) {
      return;
    }

    const data = extractReputonReviewData(wrapper);
    const reviewText = wrapper instanceof HTMLElement ? wrapper.textContent || '' : '';
    const reviewCount = parseReviewCount(data?.reviewsNumber);
    const rating = Number.parseFloat(data?.rating);
    const showSummary =
      hasContent &&
      !/no reviews yet/i.test(reviewText) &&
      Number.isFinite(rating) &&
      rating > 0 &&
      reviewCount > 0;

    if (!showSummary) {
      summary.hidden = true;
      summary.removeAttribute('data-review-summary-ready');
      return;
    }

    const score = summary.querySelector('[data-review-summary-score]');
    const count = summary.querySelector('[data-review-summary-count]');
    const stars = summary.querySelector('.product__review-summary-stars');
    const formattedRating = rating.toFixed(1);
    const formattedCount = new Intl.NumberFormat('en-US').format(reviewCount);

    if (score instanceof HTMLElement) {
      score.textContent = formattedRating;
    }

    if (count instanceof HTMLElement) {
      count.textContent = `${formattedCount} Etsy ${reviewCount === 1 ? 'review' : 'reviews'}`;
    }

    if (stars instanceof HTMLElement) {
      const percent = `${Math.max(0, Math.min(100, (rating / 5) * 100))}%`;
      stars.style.setProperty('--review-rating-percent', percent);
    }

    summary.hidden = false;
    summary.setAttribute(
      'aria-label',
      `${formattedRating} out of 5 stars across ${formattedCount} Etsy ${reviewCount === 1 ? 'review' : 'reviews'}`
    );
    summary.setAttribute('data-review-summary-ready', 'true');
  }

  function syncProductReviewRail(product) {
    if (!(product instanceof HTMLElement)) {
      return;
    }

    const wrapper = product.querySelector(reviewWrapperSelector);
    const productInfo = product.closest('product-info');
    const hasValidListingMatch = reviewPayloadMatchesExpectedListing(wrapper);
    const hasContent = wrapperHasRenderedReviews(wrapper) && hasValidListingMatch;

    product.classList.toggle('product--review-rail-active', hasContent);

    if (wrapper instanceof HTMLElement) {
      wrapper.classList.toggle('product__reviews-wrapper--has-content', hasContent);
      wrapper.toggleAttribute('hidden', !hasContent);
      wrapper.toggleAttribute('data-review-mismatch', !hasValidListingMatch);
    }

    if (productInfo instanceof HTMLElement) {
      productInfo.classList.toggle('product-info--review-rail-active', hasContent);
    }

    syncReviewSummary(product, wrapper, hasContent);
  }

  function syncAllProductReviewRails() {
    document.querySelectorAll(productSelector).forEach(syncProductReviewRail);
  }

  function formatCompactReviewLabel(reviewCount) {
    const formatted = new Intl.NumberFormat('en-US').format(reviewCount);
    return `${formatted} ${reviewCount === 1 ? 'review' : 'reviews'}`;
  }

  function syncCollectionCardReview(card) {
    if (!(card instanceof HTMLElement)) {
      return;
    }

    const summary = card.querySelector('[data-card-review-summary]');
    if (!(summary instanceof HTMLElement)) {
      return;
    }

    const handle = card.dataset.productHandle || '';
    const data = reviewMap[handle];
    const rating = Number.parseFloat(data?.rating);
    const reviewCount = parseReviewCount(data?.reviewCount);

    if (!handle || !Number.isFinite(rating) || rating <= 0 || reviewCount <= 0) {
      summary.hidden = true;
      summary.removeAttribute('data-review-summary-ready');
      return;
    }

    const stars = summary.querySelector('.card__review-summary-stars');
    const count = summary.querySelector('[data-card-review-count]');
    const countLabel = formatCompactReviewLabel(reviewCount);
    const sourceLabel = data?.source === 'seller_fallback' ? 'Etsy shop reviews' : 'Etsy product reviews';

    if (stars instanceof HTMLElement) {
      const percent = `${Math.max(0, Math.min(100, (rating / 5) * 100))}%`;
      stars.style.setProperty('--review-rating-percent', percent);
    }

    if (count instanceof HTMLElement) {
      count.textContent = countLabel;
    }

    summary.hidden = false;
    summary.setAttribute(
      'aria-label',
      `${rating.toFixed(1)} out of 5 stars from ${countLabel} on Etsy`
    );
    summary.setAttribute('title', sourceLabel);
    summary.setAttribute('data-review-summary-ready', 'true');
  }

  function syncAllCollectionCardReviews() {
    if (!isCollectionTemplate && !isIndexTemplate) {
      return;
    }

    document.querySelectorAll(collectionCardSelector).forEach(syncCollectionCardReview);
  }

  function reputonIsShowingProductSpecificReviews() {
    const data = window.reputonEtsyProductReviewsData;
    if (!data || !data.placeId || !Array.isArray(data.reviews) || data.reviews.length === 0) {
      return false;
    }
    // If any review's purchaseUrl contains the product's own Etsy listing ID, the reviews
    // are product-specific. Store-wide fallback reviews are from other listings.
    const placeId = String(data.placeId);
    return data.reviews.some(
      (r) => typeof r.purchaseUrl === 'string' && r.purchaseUrl.includes(placeId)
    );
  }

  function injectStoreReviewsNote() {
    if (!isProductTemplate) {
      return;
    }

    const data = window.reputonEtsyProductReviewsData;
    // Only inject when Reputon has loaded data but is showing store-wide fallback
    // (i.e. no reviews are from this specific listing)
    if (!data || !data.reviewsNumber || reputonIsShowingProductSpecificReviews()) {
      return;
    }

    const widget = document.querySelector(
      '.shopify-app-block .reputon-etsy-reviews-widget[data-product-reviews="true"]'
    );
    if (!(widget instanceof HTMLElement)) {
      return;
    }

    const section = widget.closest('.shopify-section');
    if (!(section instanceof HTMLElement)) {
      return;
    }

    // Idempotent — only inject once
    if (section.querySelector('.preview-theme-store-reviews-note')) {
      return;
    }

    const note = document.createElement('p');
    note.className = 'preview-theme-store-reviews-note';
    note.textContent =
      "This listing doesn\u2019t have any reviews yet, but here are some reviews from our shop:";
    section.insertBefore(note, section.firstChild);
  }

  function hideReputonAppBlockIfNoReviews() {
    if (!isProductTemplate) {
      return;
    }

    let anyBlockHidden = false;
    const currentHandle = getCurrentProductHandle();
    const mappedReviewSummary = currentHandle ? reviewMap[currentHandle] : null;
    const mappedReviewCount = parseReviewCount(mappedReviewSummary?.reviewCount);

    document.querySelectorAll('.shopify-app-block').forEach((block) => {
      const widget = block.querySelector('.reputon-etsy-reviews-widget[data-product-reviews="true"]');
      if (!(widget instanceof HTMLElement)) {
        return;
      }

      const countEl = block.querySelector('.reputon-reviews-count');
      const noReviewsInDom = countEl instanceof HTMLElement && /no reviews yet/i.test(countEl.textContent || '');
      const noReviewsInData =
        window.reputonEtsyProductReviewsData != null &&
        Number(window.reputonEtsyProductReviewsData.reviewsNumber) === 0;
      const noReviewDataLoadedYet = window.reputonEtsyProductReviewsData == null;
      const emptyWidget = blockLooksEmpty(block);
      const shouldShowStoreFallback =
        noReviewsInDom ||
        noReviewsInData ||
        (noReviewDataLoadedYet && mappedReviewCount <= 0 && emptyWidget);

      if (shouldShowStoreFallback) {
        block.hidden = true;
        anyBlockHidden = true;

        // Activate the store-wide fallback section and inject the note
        document.body.classList.add('preview-theme-store-fallback-active');
        const fallbackSection = document.querySelector('[id*="__store_reviews_fallback"]');
        if (fallbackSection instanceof HTMLElement && !fallbackSection.querySelector('.preview-theme-store-reviews-note')) {
          const note = document.createElement('p');
          note.className = 'preview-theme-store-reviews-note';
          note.textContent =
            "This listing doesn\u2019t have any reviews yet, but here are some reviews from our shop:";
          fallbackSection.insertBefore(note, fallbackSection.firstChild);
        }
      } else if (block.hidden) {
        block.hidden = false;
      }
    });

    // Sync the store-fallback body class to match actual state (handles race where
    // class was added before Reputon loaded, then product reviews arrived later)
    document.body.classList.toggle('preview-theme-store-fallback-active', anyBlockHidden);

    // When all product review blocks are hidden, collapse the right-rail column layout
    if (anyBlockHidden) {
      const productInfo = document.querySelector('product-info');
      if (productInfo instanceof HTMLElement) {
        productInfo.classList.remove('product-info--review-rail-active');
      }
      document.querySelectorAll('.product--review-rail-active').forEach((el) => {
        el.classList.remove('product--review-rail-active');
      });
    }
  }

  function syncProductDescriptionCopy() {
    if (!isProductTemplate) {
      return;
    }

    const handle = getCurrentProductHandle();
    const replacements = staleDescriptionCopyFixes[handle];

    if (!Array.isArray(replacements) || replacements.length === 0) {
      return;
    }

    document.querySelectorAll('[data-product-description-scroll]').forEach((description) => {
      if (!(description instanceof HTMLElement)) {
        return;
      }

      let updatedHtml = description.innerHTML;

      replacements.forEach((item) => {
        if (!item || typeof item.find !== 'string' || !item.find || typeof item.replace !== 'string') {
          return;
        }

        if (updatedHtml.includes(item.find)) {
          updatedHtml = updatedHtml.split(item.find).join(item.replace);
        }
      });

      if (updatedHtml !== description.innerHTML) {
        description.innerHTML = updatedHtml;
      }
    });
  }

  let frameId = 0;
  function scheduleSync() {
    if (frameId) {
      return;
    }

    frameId = window.requestAnimationFrame(() => {
      frameId = 0;
      ensureFaqHeaderLink();
      removeHomepageFaqCta();
      syncAllProductReviewRails();
      syncAllCollectionCardReviews();
      hideReputonAppBlockIfNoReviews();
      injectStoreReviewsNote();
      syncProductDescriptionCopy();
    });
  }

  ensureFaqHeaderLink();
  removeHomepageFaqCta();
  syncAllProductReviewRails();
  syncProductDescriptionCopy();
  window.addEventListener('load', scheduleSync, { once: true });
  document.addEventListener('shopify:section:load', scheduleSync);

  if (isProductTemplate) {
    const productObserver = new MutationObserver(scheduleSync);
    productObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  } else if (isCollectionTemplate || isIndexTemplate) {
    const collectionRoot =
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('.shopify-section-group-template-group') ||
      document.querySelector('main') ||
      document.body;
    const collectionObserver = new MutationObserver(scheduleSync);
    collectionObserver.observe(collectionRoot, {
      childList: true,
      subtree: true,
    });
  }

  window.setTimeout(scheduleSync, 1200);
  window.setTimeout(scheduleSync, 3000);
  window.setTimeout(scheduleSync, 6000);
})();
